import "./styles.css"

export default function Header(){
    return(
        <div className="header d-flex justify-content-center align-items-center">
            <h1 className="header-title display-1 fw-bolder">text2mc</h1>
        </div>
    )
}
